import { ProductWithUpselling } from 'services/api/entities/catalog/productWithUpsellings/types/internal/productWithUpsellings-models'
import { YupSchema, yupArray } from 'services/yup'
import { mainProductVS } from './mainProduct'

export const withUpsellingProductVS: YupSchema<ProductWithUpselling> =
  mainProductVS.shape({
    upsellingItems: yupArray(),
    upsellingItemsFull: yupArray(),
  })
